module.exports = __webpack_public_path__ + "img/8.ccf08c89.png";